// Official LOOXS gold emblem. Never redrawn or regenerated.
// Served from the backend static bucket so it lives with the codebase.
const BASE = process.env.REACT_APP_BACKEND_URL;
export const LOOXS_EMBLEM_URL = `${BASE}/api/static/brand/looxs-emblem.png`;

export default function LooxsEmblem({ size = 48, className = "" }) {
  return (
    <img
      src={LOOXS_EMBLEM_URL}
      alt="LOOXS emblem"
      draggable="false"
      className={className}
      style={{ height: size, width: "auto", display: "block" }}
    />
  );
}
